import React from 'react';
import {connect} from 'react-redux';

import Meta               from 'app/components/common/meta';
import Form               from 'app/components/forms/form';
import MainLayout         from 'app/components/layout/main-layout';
import PageLoading        from 'app/components/layout/page-loading';
import GrantsSysDuck      from 'app/ducks/grants-system';
import ProgramCard        from 'app/components/grant-system/program-card';
import helpers from 'app/helpers/grant-system';

class PageGrantPrograms extends React.PureComponent {

  constructor(props) {
    super(props);
  }

  renderPrograms() {
    const {programs} = this.props;
    if (!programs) return <p>loading...</p>;
    const showPrograms = programs.filter(p => !helpers.isEnded(p));

    return (
      <div className="page-progs-progs">
        {showPrograms.map((program) => {
          return (
            <ProgramCard key={program.id} program={program} />
          );
        })}
      </div>
    );
  }

  render() {
    const {company} = this.props;
    let title = 'Grant Programs';
    if (company) title = `${company.name} ${title}`;

    return (
      <MainLayout className="page-progs">
        <Meta title={`${title} | Millie`} />
        <div className="widther">
          <div className="page-progs-head">
            {!!company?.logoUrl && <img src={company.logoUrl} alt={company.name} className="page-progs-head-logo" />}
            <h1 className="page-progs-head-title">{title}</h1>
          </div>
          {this.renderPrograms()}
        </div>
      </MainLayout>
    );
  }

}

const stateToProps = (state) => ({
  programs: GrantsSysDuck.Slx.programs(state),
  company: GrantsSysDuck.Slx.programsCompany(state),
});
const dispatchToProps = (dispatch) => ({});

export default connect(stateToProps, dispatchToProps)(PageGrantPrograms);
